'use client';

import { Code, Flex, Heading, Link, Text, Tooltip } from '@workos-inc/design-system';
import NextLink from 'next/link';
import * as React from 'react';
export const AccessTokenDescription = ({
  scopes = []
}: {
  scopes?: string[];
}) => <Flex direction="column" gap="3" data-sentry-element="Flex" data-sentry-component="AccessTokenDescription" data-sentry-source-file="components.tsx">
    <Text as="p" size="2" data-sentry-element="Text" data-sentry-source-file="components.tsx">
      The token used to authenticate the widget.{' '}
      <Link asChild data-sentry-element="Link" data-sentry-source-file="components.tsx">
        <NextLink href="/widgets/tokens" data-sentry-element="NextLink" data-sentry-source-file="components.tsx">
          Learn more about authorization tokens.
        </NextLink>
      </Link>
    </Text>
    {scopes.length > 0 && <Text asChild size="2">
        <Flex direction="column" gap="2" p="3" style={{
      backgroundColor: 'var(--gray-3)',
      borderRadius: 'var(--radius-1)'
    }}>
          <Heading as="h2" size="1">
            Required Scopes:
          </Heading>
          <Flex asChild direction="column" gap="1" m="0" p="0" pl="4">
            <ul>
              {scopes.map(scope => <Text key={scope} asChild>
                  <li>
                    <ScopeChip>{scope}</ScopeChip>
                  </li>
                </Text>)}
            </ul>
          </Flex>
        </Flex>
      </Text>}
  </Flex>;
export type WidgetSessionScope = 'widgets:users-table:manage' | 'widgets:domain-verification:manage' | 'widgets:sso:manage' | 'widgets:dsync:manage' | 'widgets:api-keys:manage';
const ScopeChip = ({
  children
}: {
  children: string;
}) => {
  const [copyTimeout, setCopyTimeout] = React.useState<number | null>(null);
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  return <Tooltip content={copyTimeout ? 'Copied' : 'Copy'} open={copyTimeout !== null || tooltipOpen} onOpenChange={setTooltipOpen} data-sentry-element="Tooltip" data-sentry-component="ScopeChip" data-sentry-source-file="components.tsx">
      <Code asChild data-sentry-element="Code" data-sentry-source-file="components.tsx">
        <button type="button" onClick={event => {
        const textContents = event.currentTarget.textContent;
        if (!textContents) {
          return;
        }
        void navigator.clipboard.writeText(textContents);
        if (copyTimeout) {
          window.clearTimeout(copyTimeout);
        }
        setCopyTimeout(window.setTimeout(() => setCopyTimeout(null), 3000));
      }} onMouseLeave={() => {
        if (copyTimeout) {
          window.clearTimeout(copyTimeout);
          setCopyTimeout(null);
        }
      }}>
          {children}
        </button>
      </Code>
    </Tooltip>;
};